// layouts
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';

import styled, { css } from 'styled-components';

import {
  requestRolePermissionStart,
  REQUEST_ROLE_PERMISSION_SUCCESS,
  REQUEST_ROLE_PERMISSION_FAIL,
} from '@actions/role-permission';

import getConfig from 'next/config';

import navConfig from 'src/layouts/dashboard/SidebarConfig';

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();

console.info(`serverRuntimeConfig:`, serverRuntimeConfig);
console.info(`publicRuntimeConfig:`, publicRuntimeConfig);

function LandingPage(props) {

  const { appPermission } = props;

  const router = useRouter();
  const [isInit, setInit] = useState(false);
  // const [menuActiveList, setMenuActiveList] = useState([]);


  useEffect(() => {

    if (!isInit) {

      // console.log('Landing : ', { navConfig })

      switch (appPermission?.type) {
        case REQUEST_ROLE_PERMISSION_SUCCESS:
          {

            const { permission = [] } = appPermission?.permission_info || {};
            const _list = permission.map(({ permission_select, permission_key }) => ((permission_select) ? permission_key : null)).filter((_item) => _item) || [];

            const _menuList = navConfig.map((info) => {

              const { items = [] } = info || {};

              const _items = items.map((menu) => {

                const { permission_key, children = [] } = menu;

                if ((children.length === 0) && _list.includes(permission_key))
                  return menu;
                else if (children.length > 0) {

                  return { ...menu, children: children.map((subMenu) => (_list.includes(subMenu?.permission_key) ? subMenu : false)).filter((_item) => _item) };
                }
                else
                  return { ...menu, children: [] };
              })

              return { ...info, items: _items.filter((item) => !item?.children || item?.children?.length > 0) }

            })

            // console.log("Landing : [rolePermission][landing] ", { _list, navConfig, _menuList })

            if (_menuList.length > 0) {

              const { path } = _menuList[0]?.items[0] || {};

              // console.log("Landing : [rolePermission][landing] ", path)

              if (Boolean(path))
                router.push(path);
              else
                router.push('/permission-denied');

              // setInit(true);
            }
            else {
              router.push('/permission-denied');
            }

          } break;
        case REQUEST_ROLE_PERMISSION_FAIL:
          {
            router.push('/permission-denied');

          } break;
      }
    }

  }, [isInit, appPermission?.type])

  return (isInit &&
    (<div>

    </div>)
  );
}



const mapStateToProps = state => ({ appPermission: state?.rolePermission?.data || {} });

const mapDispatchToProps = dispatch => ({
  // setSystemsInfo: (data) => dispatch(requestSetSystemsInfo(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(styled(LandingPage)`${css}`);












